module.exports = __webpack_public_path__ + "static/media/Desktop_Home.47dedbd7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ewcc/Desktop_Home.png
// module id = 97
// module chunks = 0